<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input placeholder="请输入单据编号" v-model="queryParam.billNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="流程类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select placeholder="请选择流程类型" allow-clear v-model="queryParam.billType">
                  <a-select-option v-for="(n, k) in billTypes" :key="k" :value="k">{{ n }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select placeholder="请选择状态" allow-clear v-model="queryParam.status">
                  <a-select-option value="审核中">审核中</a-select-option>
                  <a-select-option value="流程结束">流程结束</a-select-option>
                  <a-select-option value="已撤回">已撤回</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </a-col>
            </span>
          </a-row>
        </a-form>
      </div>
      <a-table
        rowKey="instanceId"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange">
        <template slot="billType" slot-scope="text">
          {{ billTypeName(text) }}
        </template>
        <template slot="instanceStatus" slot-scope="text">
          <a-tag :color="statusColor(text)">{{ text }}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a v-if="record.instanceStatus === '审批中'" @click="doCancel(record)">撤回</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
  import { submitList, cancelInstance } from './api'

  const BILL_TYPE_NAMES = {
    'CGRK': '采购入库', 'CGTH': '采购退货', 'XSCK': '销售出库', 'XSTH': '销售退货',
    'LSCK': '零售出库', 'LSTH': '零售退货', 'QTRK': '其它入库', 'QTCK': '其它出库',
    'DBCK': '调拨出库', 'ZZD': '组装单', 'CXD': '拆卸单',
    'QGD': '请购单', 'CGDD': '采购订单', 'XSDD': '销售订单',
    'PDLR': '盘点录入', 'PDFP': '盘点复盘', 'NSLD': '资产申领', 'NCKD': '资产出库',
    'SR': '收入单', 'ZC': '支出单', 'SK': '收款单', 'FK': '付款单', 'ZZ': '转账单', 'SYF': '收预付款', 'FTDD': '发图订单'
  }

  export default {
    name: 'SubmitTaskList',
    data() {
      return {
        loading: false,
        dataSource: [],
        queryParam: { billNo: '', billType: undefined, status: undefined },
        labelCol: { xs: { span: 24 }, sm: { span: 6 } },
        wrapperCol: { xs: { span: 24 }, sm: { span: 18 } },
        billTypes: BILL_TYPE_NAMES,
        columns: [
          { title: '单据类型', dataIndex: 'billType', scopedSlots: { customRender: 'billType' } },
          { title: '单据编号', dataIndex: 'billNo' },
          { title: '流程状态', dataIndex: 'instanceStatus', scopedSlots: { customRender: 'instanceStatus' } },
          { title: '发起时间', dataIndex: 'startTime' },
          { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 100 }
        ],
        pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: (total) => `共 ${total} 条` }
      }
    },
    mounted() {
      this.loadData()
    },
    methods: {
      billTypeName(type) {
        return BILL_TYPE_NAMES[type] || type
      },
      statusColor(status) {
        if (status === '通过') return 'green'
        if (status === '驳回') return 'red'
        if (status === '审批中') return 'blue'
        return 'default'
      },
      loadData() {
        this.loading = true
        const param = {
          currentPage: this.pagination.current,
          pageSize: this.pagination.pageSize,
          billNo: this.queryParam.billNo || undefined,
          billType: this.queryParam.billType || undefined,
          status: this.queryParam.status || undefined
        }
        submitList(param).then((res) => {
          if (res && res.code === 200 && res.data) {
            this.dataSource = res.data.rows || []
            this.pagination.total = res.data.total || 0
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleTableChange(pagination) {
        this.pagination.current = pagination.current
        this.pagination.pageSize = pagination.pageSize
        this.loadData()
      },
      searchQuery() {
        this.pagination.current = 1
        this.loadData()
      },
      searchReset() {
        this.queryParam = { billNo: '', billType: undefined, status: undefined }
        this.pagination.current = 1
        this.loadData()
      },
      doCancel(record) {
        this.$confirm({
          title: '确认撤回',
          content: '确定撤回该流程吗？撤回后单据将回到未审核状态。',
          onOk: () => {
            return cancelInstance({ instanceId: record.instanceId }).then((res) => {
              if (res && res.code === 200) {
                this.$message.success('已撤回')
                this.loadData()
              } else {
                this.$message.warning(res.data && res.data.message ? res.data.message : '撤回失败')
              }
            })
          }
        })
      }
    }
  }
</script>